import {
    DirectBudgetType,
    DirectPayForType,
    DirectPromotionGoalUI,
    DirectSpendLimitType,
    DirectStrategyType,
} from '../../../data-layer/direct/types';
import { MAX_CRR_VALUE } from '../../../ui/business/ContentPromotionBudget/parts/ContentPromotionBudgetStrategy/constants';
import { PostStatus } from '../../../ui/posts/constants';
import { getContentPromotionGoalsSettings } from '../../../utils/getContentPromotionGoalsSettings';
import type { PostCollectionFilters } from '../../post/usePostCollection';

export const makePostsFilters = (): Partial<PostCollectionFilters> =>
    ({ statuses: [PostStatus.PUBLISHED] }) as any;

export interface IsCampaignDisabledProps {
    selectedRegions: Record<string, string>;
    selectedGoals: DirectPromotionGoalUI;
    selectedCounters: string[];
    weeklyLimit?: number;
    date: string;
    isSaving?: boolean;
    strategyType: DirectStrategyType;
    payFor: DirectPayForType;
    budgetType: DirectBudgetType;
    spendLimitType: DirectSpendLimitType;
    spendLimitAmount?: number;
}

export const isCampaignDisabled = (props: IsCampaignDisabledProps) => {
    const {
        selectedRegions,
        selectedGoals,
        selectedCounters,
        weeklyLimit,
        date,
        isSaving,
        strategyType,
        spendLimitType,
        payFor,
    } = props;

    return (
        !isGoalsValid(selectedCounters, selectedGoals, strategyType, spendLimitType, payFor) ||
        !weeklyLimit ||
        !date ||
        !isStrategyValid(props) ||
        isSaving ||
        !Object.keys(selectedRegions).length
    );
};

export const isGoalsValid = (
    selectedCounters: string[],
    selectedGoals: DirectPromotionGoalUI,
    strategyType: DirectStrategyType,
    spendLimitType: DirectSpendLimitType,
    payFor: DirectPayForType,
) => {
    const goals = Object.values(selectedGoals);
    const { disableCost, isRequiredMetrics } = getContentPromotionGoalsSettings({
        selectedCounters,
        selectedGoals,
        strategyType,
        spendLimitType,
        payFor,
    });

    return !isRequiredMetrics || (goals.length && (goals.every((cost) => cost) || disableCost));
};

export const isStrategyValid = (props: IsCampaignDisabledProps) => {
    const { spendLimitType, spendLimitAmount } = props;

    if (spendLimitType === DirectSpendLimitType.AVERAGE_CPC) {
        return spendLimitAmount && spendLimitAmount > 0;
    }

    if (spendLimitType === DirectSpendLimitType.CRR) {
        return spendLimitAmount && spendLimitAmount > 0 && spendLimitAmount <= MAX_CRR_VALUE;
    }

    return true;
};
